import LogoDW from '../vectors/logo-dw';
import classes from './ph4se.module.css';
import { Link } from 'react-router-dom';

const Ph4se = () => {
  return (
    <div className={classes.container}>
      <img src="/img/ph4se/logo-ph4se.png" alt="Phase 4 logo" />
      <Link to="/damien-watson" className={classes.dw}>
        <LogoDW
          primary="#fff"
          secondary="#316293"
        />
      </Link>
    </div>
  );
};

export default Ph4se;
